import React, { Component } from "react";
import BsyTableList from "../BsyTableList";
import BsyGroupList from "../BsyGroupList";
import BsySwitchBtn from "../BsySwitchBtn";
import BsyIconBtn from "../BsyIconBtn";
import BsySearchInput from "../BsySearchInput";
import BsyAlertListDetail from '../BsyAlertListDetail'
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyAlertInviteUser from "../BsyAlertInviteUser";
import { BsyUtils } from "../../utils/Utils";
import BsyDialog from '../BsyDialog';
import BsyApprovePane from '../BsyApprovePane';
import BsyAlertHandover from "../BsyAlertHandover";
import BsySlidePane from '../BsySlidePane';
import CorpCoopDeatilsPane from "./CorpCoopDeatilsPane";
import AddCorpCoopPane from "./AddCorpCoopPane"
import CorpCoopOtherSetPane from "./CorpCoopOtherSetPane"
import emptyImg from "../../images/img_hulian@2x.png";
import emptyImg2 from "../../images/img_qiye@2x.png";
import emptyImg3 from "../../images/img_sousuo@2x.png";

import CorpCoopRolePane from './CorpCoopRolePane';
import './index.css';

export default class BsyCorpCoop extends Component{
    constructor(props) {
        super(props);
        this.state = {
            filterText: React.language('all'),
            corpCoopList: [],
            contactList: [],
            corpList:[],
            hasCount: true,
            limit: 20,
            skip: 0,
            dock_corp: [],
            filter: "",
            miniAppSet: false, //小程序设置
            isCheck: false,
            selectGroup: 'corpCoopAll',
            selectType: 'corpCoopAll',
            selectGroupName: React.language("contact.corp.all"),
            openurl: '',
            inviteStatus: 0,
            isFilter: false,
            role_id: 0,
            label_id: 0,
            openurl_switch: false,
            audit_switch: false,
            userCont: {},
            nocheck: false, //批量导入外部联系不 不验证
            checkList: [],
            checkListDetail: [],
            keyword:"",
            hasRole: false,
            hasLabel: false,
            hasCorpList: false,
            isLoading: true,
            emailCodeLogin: true,
            mobileCodeLogin: true,
            owner_coprs: [],
        }
        this.corpContEl = React.createRef();
    }

    componentDidMount(){
        React.axios('/corp/dock/member/join_link', {
            corpId: window.FX.STATIC.corpId
        }).then(res => {
            this.setState({ 
                emailCodeLogin: res.data.emailCodeLogin,
                mobileCodeLogin: res.data.mobileCodeLogin,
            },()=>{
                this.ReallList(true);
            })
        })
    }

    ReallList = (noRefres) =>{
        this.setState({
            isLoading: !!noRefres
        },()=>{
            React.axios("/corp/dock/label/list",{}).then((res)=>{
                React.axios("/corp/dock/role/list",{}).then((res1)=>{
                    let corpCoopMap = {};
                    let contactMap = {};
                    res.data.label_list.map(res =>{
                        corpCoopMap[res.id] = res;
                    })
            
                    res1.data.role_list.map(res =>{
                        contactMap[res.id] = res;
                    })
    
                    this.setState({
                        corpCoopList: res.data.label_list.map((val)=>{
                            val.icon = "icon-corp-label";
                            val.type = "labelCorp";
                            return val;
                        }),
                        contactList: res1.data.role_list.map((val)=>{
                            val.icon = "icon-role";
                            return val;
                        }),
                        corpCoopMap,
                        hasLabel: res.data.label_list && res.data.label_list.length > 0,
                        hasRole: res1.data.role_list && res1.data.role_list.length > 0,
                        contactMap,
                        isLoading: false
                    },()=>{
                        this.RefreshList(true);
                    })
                    
                })
            })
        })
        
    }

    RefreshList = (noRefres, cd) =>{
        const {selectType, limit, skip, keyword, role_id, inviteStatus, label_id } = this.state;
        let mask = window.FX.Utils.createLoadLayer(window.$(this.corpContEl.current), {
            hasLoader: !0
        })
        this.setState({
            isLoading: true
        },()=>{
            this.refreshlist = setTimeout(()=>{
                if(selectType === "corpCoopAll"){
                    React.axios("/corp/dock/corp/list",{
                        keyword, limit, skip, label_id, status: inviteStatus
                    }).then((res2)=>{
                        this.refreshlist && clearTimeout(this.refreshlist);
                        const corpList = res2.data.corp_list.map((val)=>{
                            val.id = val.id;
                            return val;
                        });
                        this.setState({
                            corpList: corpList,
                            hasCorpList: res2.data.corp_list && res2.data.corp_list.length > 0,
                            count: res2.data.count,
                            not_verified: res2.data.not_verified,
                            owner_coprs: res2.data.owner_coprs,
                            isLoading: false
                        })
                        mask && mask.remove();
                        this.closeCheckMenu();
                        cd && cd(corpList)
                    })
                }else{
                    React.axios("/corp/dock/member/list",{
                        keyword, limit, skip, role_id, status: inviteStatus
                    }).then((res2)=>{
                        this.refreshlist && clearTimeout(this.refreshlist);
                        this.setState({
                            corpList: res2.data.member_list,
                            hasCorpList: res2.data.member_list && res2.data.member_list.length > 0,
                            count: res2.data.count,
                            not_verified: res2.data.not_verified,
                            dock_corp: res2.data.dock_corp,
                            owner_coprs: res2.data.owner_coprs,
                            isLoading: false
                        })
                        mask && mask.remove();
                        this.closeCheckMenu();
                        cd && cd(res2.data.member_list)
                    })
                }
            },30)
        })
    }

    outsiderNodeClick = (node, e) => {
        if(this.state.selectGroup === node.id){
            return
        }
        this.setState({
            limit: 20,
            skip: 0,
            checkList:[],
            checkListDetail: [],
            checked: false,
            role_id: node.role_id,
            label_id: node.label_id,
            selectGroup: node.role_id || node.label_id,
            filter: "",
            inviteStatus: 0,
            isFilter: false,
            keyword:"",
            selectType: e,
            selectGroupName: node ? node.name : React.language("contact.corp.all"),
            filterText: React.language('all')
        }, () => {
            this.RefreshList();
            // this.get_approve_list();
        })
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        // const first = result.splice(0, 1);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    outsiderGroupNodeMove = (attr, list, type) => {
        if(type === "role"){
            let data;
            let url;
            const customGroup = [...this.state.contactList];
            const groupList = this.reorder(
                customGroup,
                attr.source.index,
                attr.destination.index
            );
            const outsiders = [...groupList];
            data = {
                "role_id": attr.draggableId,  //被移动的成员
                "prev": attr.destination.index === 0 ? "" : outsiders[attr.destination.index - 1].id
            }
            url = "/corp/dock/role/sort";
            this.setState({
                contactList: outsiders
            }, () => {
                React.axios(url, data).then(res => {
                    
                }).catch(res => {
    
                })
            });
        } else if(type === "label"){
            let data;
            let url;
            const customGroup = [...this.state.corpCoopList];
            const groupList = this.reorder(
                customGroup,
                attr.source.index,
                attr.destination.index
            );
            const outsiders = [...groupList];
            console.log(outsiders)
            data = {
                "label_id": attr.draggableId,  //被移动的成员
                "prev": attr.destination.index === 0 ? "" : outsiders[attr.destination.index - 1].id
            }
            url = "/corp/dock/label/sort";
            this.setState({
                corpCoopList: outsiders
            }, () => {
                React.axios(url, data).then(res => {
                    
                }).catch(res => {
    
                })
            });
        }
    }

    outsiderNodeAdd = () => {
        const _this = this;
        var f = new window.FX.ConfirmDialog({
            title: React.language("outsider.add"),
            width: 340,
            height: 170,
            text4Ok: React.language("add"),
            contentWidget: {
                rowSize: [30],
                colSize: [300],
                padding: 20,
                items: [[{
                    type: "text",
                    widgetName: "groupName",
                    waterMark: React.language('outsider.name.required'),
                    allowBlank: !1
                }]]
            },
            onOk: function () {
                var g = this.getWidgetByName("groupName");
                var value = g.getValue();
                if (!value) {
                    tipAlert({
                        type: "warning",
                        msg: React.language('outsider.name.empty')
                    })
                    return;
                }
                React.axios("/corp/outsider/create",
                    { "name": value })
                    .then(res => {
                        BsyUtils.showAjaxTip(res.data, () => {
                            const newOutsiders = [..._this.state.outsiders, ...[res.data.data]]
                            _this.setState({ outsiders: newOutsiders })
                            f.close()
                        })
                    }).catch(res => {
                        console.log(res)
                    })
            }
        });
        f.show()
    }

    eventCustMent = (type, node, event) => {

        const { outsiders, selectType, selectGroup } = this.state;
        switch (type) {
            case "del": {
                BsyAlert({
                    title: React.language("delete.confirm", {
                        name: node.name
                    }),
                    msg: selectType === "corpCoopAll" ? React.language("corp.coop.delete.tip") : selectType === "contactAll" ? React.language("corp.role.delete.tip") : "",
                    type: "warning",
                    text4Ok: React.language("delete"),
                    OkType: "red",
                    text4Cancel: React.language("cancel"),
                    ok: () => {
                        let data = selectType === "corpCoopAll" ? {label_id: node.label_id} : selectType === "contactAll" ? {role_id: node.role_id} : {};
                        let url = selectType === "corpCoopAll" ? "/corp/dock/label/delete" : selectType === "contactAll" ? "/corp/dock/role/delete" : "";
                        React.axios(url, data).then(res => {
                            this.setState({selectGroup: selectType, label_id: 0, role_id: 0, checkList:[], checkListDetail: [], checked: false, selectType, keyword: "",selectGroupName:selectType === "corpCoopAll" ? React.language('contact.corp.all') : React.language('contact.handover.all')},()=>{
                                BsyUtils.showAjaxTip(res.data, () => {
                                    this.ReallList()
                                })
                            })
                        }).catch(res => {

                        })
                    }
                })
                break;
            }
            case 'rename': {
                const _this = this;
                if(event){
                    window.FX.Msg.nAlter({
                        renderEl: window.$(event.target),
                        title: null,
                        hasTitle: false,
                        name: node.name,
                        placeholder: React.language("name.placeholder"),
                        onOk: function (c2) {
                            var value = "";
                            if (!!c2.checkValidate()) {
                                value = c2.getValue();
                            }
                            if (!value) {
                                let tip = selectType === "corpCoopAll" ? React.language('corp.label.empty.tip') : selectType === "contactAll" ? React.language('corp.role.empty.tip') : "";
                                tipAlert({
                                    type: "warning",
                                    msg: tip
                                })
                                return;
                            }
                            if (node.name === value) {
                                return;
                            }

                            if (value.length > 32) {
                                let tip = selectType === "corpCoopAll" ? React.language('corp.label.max.tip',{length: 32}) : selectType === "contactAll" ? React.language('corp.role.max.tip',{length: 32}) : "";
                                tipAlert({
                                    type: "warning",
                                    msg: tip
                                })
                                return;
                            }
    
                            let data = selectType === "corpCoopAll" ? {"name": value, label_id: node.label_id} : selectType === "contactAll" ? {"name": value, role_id: node.role_id} : {};
                            let url = selectType === "corpCoopAll" ? "/corp/dock/label/update" : selectType === "contactAll" ? "/corp/dock/role/update" : "";
    
                            React.axios(url,data).then(res => {
                                if(res.data.errcode !== 0){
                                    tipAlert({
                                        type: "warning",
                                        msg: res.data.errmessage
                                    })
                                    return
                                }
                                BsyUtils.showAjaxTip(res.data, () => {
                                    _this.setState({selectGroupName: value},()=>{_this.ReallList()});
                                })
    
                            }).catch(res => {
                                // console.log(res)
                            })
                        }
                    })
                }
                break;
            }
            default: {

            }
        }
    }
    
    outsiderGroupMoreOperate = (e, node) => {
        if (node.type == 1) {
            this.eventCustMent('rename', node);
        } else {
            let menu = [{
                text: React.language('rename'),
                colorType: "",
                click: () => {
                    this.eventCustMent('rename', node, e);
                }
            }, {
                text: React.language('delete'),
                colorType: "red",
                click: () => {
                    this.eventCustMent('del', node);
                }
            }]
            BsyAlertMenu({
                item: menu,
                width: 140,
                target: e.currentTarget,
            })

        }

    }

    getCorpCoopValue = (e) =>{
        this.addCorpCoopEl = e;
    }

    getContactValue = (e) =>{
        this.addContactEl = e;
    }

    addCoopPane = (checkList, checkListDetail) =>{
        const {corpList, selectGroup} = this.state;

        BsyDialog({
            title: React.language('dept.label.add'),
            height: 460,
            width: 460,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AddCorpCoopPane isCoop={true} getEl={this.getCorpCoopValue} checkList={checkList ? checkList : []} checkListDetail={checkListDetail ? checkListDetail : []} corpList={corpList} selectGroup={selectGroup} />
            },
            onOk: ()=>{
                if(this.addCorpCoopEl.state.coopName === ""){
                    tipAlert({
                        type: "warning",
                        msg: React.language('label.name.notEmpty')
                    })
                    return !1
                }
                this.addCoopData();
            }
        })
    }

    addCoopData = () =>{

        React.axios("/corp/dock/label/create",{
            name: this.addCorpCoopEl.state.coopName,
            dock_corp_id_list: this.addCorpCoopEl.state.checkList.length > 0 ? this.addCorpCoopEl.state.checkList : this.addCorpCoopEl.state.dock_corp_id_list
        }).then(res=>{
            if(res.data.errcode === 1){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
                return
            }
            this.ReallList();
        })
    }

    addContactData = () =>{

        React.axios("/corp/dock/role/create",{
            name: this.addContactEl.state.coopName,
            member_id_list: this.addContactEl.state.checkList.length > 0 ? this.addContactEl.state.checkList : this.addContactEl.state.dock_corp_id_list
        }).then(res=>{
            if(res.data.errcode === 1){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
                return
            }
            this.ReallList();
        })
    }

    addContactPane = (checkList, checkListDetail) =>{
        const {corpList, selectGroup} = this.state;
        BsyDialog({
            title: React.language('contact.handover.role.add'),
            height: 460,
            width: 461,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AddCorpCoopPane isCoop={false} getEl={this.getContactValue} checkList={checkList ? checkList : []} checkListDetail={checkListDetail ? checkListDetail : []} corpList={corpList} selectGroup={selectGroup} />
            },
            onOk: ()=>{
                if(this.addContactEl.state.coopName === ""){
                    tipAlert({
                        type: "warning",
                        msg: React.language('contact.role.notEmpty')
                    })
                    return !1
                }
                this.addContactData();
            }
        })
    }

    openNewConnection = () =>{
        const { corpCoopList, contactList, contactMap, corpCoopMap } = this.state;
        BsyAlertInviteUser({
            title: React.language('contact.connection.new'),
            styleCss: {
                width: 966,
                height: 620
            },
            type:"corpCoop",
            corpCoopList,
            contactList,
            contactMap,
            corpCoopMap,
            onRefresh: () => {
                this.RefreshList()
            },
        })
    }

    skipChange = (e) =>{
        this.setState({skip: e},()=>{this.RefreshList()})
    }

    listLimitChange = (e) =>{
        this.setState({limit: e},()=>{this.RefreshList()})
    }

    listFilterChange = (e) =>{
        console.log(e)
    }
    
    handleUserOrder = (e) =>{
        console.log(e)
    }

    againInvite = (e, a) =>{
        const {selectType, role_id, selectGroup, label_id } = this.state;
        let data = {};
        if(selectType === "contactAll"){
            if(e){
                data = {
                    dock_corpid: e.dock_corpid,
                    memberIds: [e.user_id],
                    role_id: e.role_id,
                };
            }else{
                data = {
                    dock_corpid: [],
                    memberIds: [],
                    role_id: selectGroup === "contactAll" ? [] : role_id,
                };
            }
            
        }else{
            if(e){
                data = {
                    dock_corpid: [e.dock_corpid],
                    label_id: e.label_id,
                };
            }else{
                data = {
                    dock_corpid: [],
                    label_id: selectGroup === "corpCoopAll" ? [] : label_id,
                };
            }
        }
        React.axios(selectType === "contactAll" ? '/corp/dock/member/reinvite' : '/corp/dock/corp/reinvite',data).then((res)=>{
            if(res.data.errcode !== 0){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
                return
            }
            tipAlert({
                type: 'success',
                msg: React.language('Invited.tip3')
            })
            this.RefreshList()
        })
    }

    memberRowClick = (event, item) =>{
        const {selectGroup, corpCoopMap, contactMap, selectType, corpCoopList, owner_coprs, emailCodeLogin, mobileCodeLogin } = this.state;
        
        if (event.target.classList[0] === "icon-flow-other" || event.target.classList[0] === "menuTd") {
            let menu = [{
                text: React.language('edit'),
                colorType: "",
                click: () => {
                    if(selectType === "corpCoopAll"){
                        BsyAlertListDetail({
                            type: "custom",
                            width: 700,
                            createContent:(e)=>{
                                return <CorpCoopDeatilsPane owner_coprs={owner_coprs} emailCodeLogin={emailCodeLogin} mobileCodeLogin={mobileCodeLogin} RefreshList={this.RefreshList} newProps={e} item={item} corpCoopList={corpCoopList} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} onChangeDockCorpName={this.onChangeDockCorpName} />
                            }
                        })
                    }else{
                        BsyAlertListDetail({
                            type: "custom",
                            width: 400,
                            clsName: "BsyAlertCorpCoopRolePane",
                            createContent:(e)=>{
                                return <CorpCoopRolePane owner_coprs={owner_coprs} emailCodeLogin={emailCodeLogin} mobileCodeLogin={mobileCodeLogin} RefreshList={this.RefreshList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} onChangeDockCorpName={this.onChangeDockCorpName} />
                            }
                        })
                    } 
                }
            },{
                text: selectGroup === "corpCoopAll" ? React.language('contact.connection.remove') : React.language('remove.out'),
                colorType: "red",
                click: () => {
                    this.removeCorpLabel(item);
                }
            }];

            BsyAlertMenu({
                item: menu,
                // renderEl: event.currentTarget,
                width: 140,
                target: event.target
            })
        } else if (event.target.classList[1] === "again") {
            // const mobile = item.phone
            // if (!mobile) {
            //     tipAlert({
            //         type: "warning",
            //         msg: React.language("Invited.tip1")
            //     })
            //     return;
            // }
            this.againInvite(item)

        } else {
            if(selectType === "corpCoopAll"){
                BsyAlertListDetail({
                    type: "custom",
                    width: 700,
                    createContent:(e)=>{
                        return <CorpCoopDeatilsPane owner_coprs={owner_coprs} emailCodeLogin={emailCodeLogin} mobileCodeLogin={mobileCodeLogin} RefreshList={this.RefreshList} newProps={e} item={item} corpCoopList={corpCoopList} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} onChangeDockCorpName={this.onChangeDockCorpName} />
                    }
                })
            }else{
                BsyAlertListDetail({
                    type: "custom",
                    width: 400,
                    clsName: "BsyAlertCorpCoopRolePane",
                    createContent:(e)=>{
                        return <CorpCoopRolePane owner_coprs={owner_coprs} emailCodeLogin={emailCodeLogin} mobileCodeLogin={mobileCodeLogin} RefreshList={this.RefreshList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} onChangeDockCorpName={this.onChangeDockCorpName} />
                    }
                })
            } 
        }
    }

    onChangeDockCorpName = (item) =>{
        const {corpList} = this.state;
        let corpItme = corpList;
        corpItme.map((val)=>{
            if(val.id === item.id){
                val = item;
            }
        })
        this.setState({corpList:corpItme})
    }

    verifyEmailMobile = () =>{

    }

    getSearchValue = () =>{

    }

    onSearch = (e) =>{
        this.setState({keyword: e},() =>{
            this.RefreshList()
        })
    }

    filterPane = (event, type) => {
        let bts = [
          { icon: '', text: React.language('all'), click: () =>{
            this.setState({filterText: React.language('all'), inviteStatus: 0, isFilter: true},()=>{
                this.RefreshList()
            })
          }},
          { icon: '', text: React.language('member.inviting'), click: () =>{
            this.setState({filterText: React.language('member.inviting'), inviteStatus: 1, isFilter: true},()=>{
                this.RefreshList()
            })
          }},
        ]
        const t = event.currentTarget;
        t.classList.add('open');
        BsyAlertMenu({
            item: bts,
            width: 120,
            target: t,
            customCls: ' data-manage-batch-menu ',
            onClose: ()=>{
                t.classList.remove('open');
                return !0
            }
        })
    }

    onBsyTurnPageMid = () => {
        const { not_verified, selectType } = this.state;
        return <>
            {not_verified > 0 && (selectType === "corpCoopAll" ? <div className="tip-list">
                
                <div className="joined-tip tip-item" onClick={e => { this.againInvite(null, 'all') }}  >
                    {/* <i className={'icon-bsy-laba'} /> */}
                    <div dangerouslySetInnerHTML={{ __html: React.language('contact.corp.not.connection.tip', { count: not_verified }) }} />
                </div>
                <div className="validate-tip tip-item" onClick={e => { this.againInvite() }}  >
                    {/* <i className={'icon-bsy-laba'} /> */}
                    <div>{React.language('invite.again')}</div>
                </div>
            </div> : <div className="tip-list">
                
                <div className="joined-tip tip-item" onClick={e => { this.againInvite(null, 'all') }}  >
                    {/* <i className={'icon-bsy-laba'} /> */}
                    <div dangerouslySetInnerHTML={{ __html: React.language('contact.handover.invite.tip', { count: not_verified }) }} />
                </div>
                <div className="validate-tip tip-item" onClick={e => { this.againInvite() }}  >
                    {/* <i className={'icon-bsy-laba'} /> */}
                    <div>{React.language('contact.handover.add.all.again')}</div>
                </div>
            </div>)}
        </>
    }

    getTableValue = (rel) => {
        this.tableValue = rel;
        console.log(rel)
    }

    onCheck = (e) =>{
        this.setState({checkList: e.checkList, checkListDetail: e.checkListDetail, checked: e.checked})
    }

    closeCheckMenu = () =>{
        this.setState({checkList: [], checkListDetail: [], checked: false})
    }

    openOtherSetPane = () => {
        BsySlidePane({
            title: React.language('datahelper.trigger.config.next1'),
            hasHeader: true,
            onContentCreate: (ref) => {
                return <CorpCoopOtherSetPane alertDom={ref} />
            },
            onClose: () =>{
                this.ReallList();
            }
        })
    }

    openAddCorpLabel = () =>{
        const _this = this;
        const {dock_corp_id_list, selectGroup} = this.state;
        React.axios("/corp/dock/corp/list_all").then(res=>{
            const d = new window.FX.ConfirmDialog({
                title: React.language("contact.corp.list"),
                height: 570,
                width: 710,
                contentWidget: {
                    rowSize: [440],
                    colSize: [680],
                    padding: 15,
                    items: [[{
                        widgetName: "memberSelect",
                        type: "memberselectpane",

                        editable: !0,
                        memberEnable: !1,
                        departmentEnable: !1,
                        outsiderMemberEnable: !1,
                        outsiderGroupEnable: !1,
                        roleEnable: !1,
                        corpEnable: !0,
                        dynamicEnable: !1,
                        dynamicType: "set",
                        hasMenuType:false,
                        items: res.data.corp_list,
                    }]]
                },
                onOk: function () {
                    var dept = d.getWidgetByName("memberSelect");
                    var d1 = dept.getAllJsonValue();
                    _this.setState({dock_corp_id_list: d1.dockcorpValue},()=>{
                        React.axios("/corp/dock/label/update",{
                            label_id: selectGroup,
                            dock_corp_id_list: d1.dockcorpValue
                        }).then(res=>{
                            _this.ReallList();
                        });
                    });
                    return !1;
                }
            });
            d.show()
        })
    }

    openAddRole = () =>{
        const _this = this;
        const { selectGroup} = this.state;
        React.axios("/corp/dock/corp/list").then(res=>{
            const d = new window.FX.ConfirmDialog({
                title: React.language("contact.handover.list"),
                height: 576,
                width: 710,
                contentWidget: {
                    rowSize: [440],
                    colSize: [680],
                    padding: 15,
                    items: [[{
                        widgetName: "memberSelect",
                        type: "memberselectpane",

                        editable: !0,
                        memberEnable: !1,
                        departmentEnable: !1,
                        outsiderMemberEnable: !1,
                        outsiderGroupEnable: !1,
                        roleEnable: !1,
                        corpEnable: !1,
                        corpDeptEnable: !0,
                        dynamicEnable: !1,
                        dynamicType: "set",
                        hasMenuType:false,
                        itemTitle: React.language("contact.docking.people"),
                        menuItems: res.data.corp_list,
                    }]]
                },
                onOk: function () {
                    var dept = d.getWidgetByName("memberSelect");
                    var d1 = dept.getAllJsonValue();
                    _this.setState({dock_corp_id_list: d1.dockcorpValue},()=>{
                        React.axios("/corp/dock/member/role_add",{
                            role_id: selectGroup,
                            user_id: d1.users
                        }).then(res1=>{
                            if(res1.data.errcode !== 0){
                                tipAlert({
                                    type: 'warning',
                                    msg: res1.data.errmessage
                                })
                                return
                            }
                            _this.ReallList();
                        });
                    });
                    return !1;
                }
            });
            d.show()
        })
    }

    onLeading = () =>{
        React.axios("/corp/dock/member/export").then(res=>{
            window.open(res.data.data.info)
        })
    }

    openAddCorpRoleBatch = (event) =>{
        const {contactList, checkList, checkListDetail} = this.state;

        let menu = contactList.map((res, key)=>{
            return {
                text: res.name,
                colorType: "",
                line: key === contactList.length - 1,
                click: () => {
                    let userId = checkListDetail.map(res1=>{
                        return [res1.dock_corpid, res1.user_id]
                    })
                    React.axios("/corp/dock/member/batch_update",{
                        'user_id': userId, //必填
                        "role_id_list":res.role_id
                    }).then(res1=>{
                        if(res1.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res1.data.errmessage
                            })
                            return
                        }
                        tipAlert({
                            type: "success",
                            msg: React.language("datahelper.trigger.output.filter.ok.tip")
                        })
                        this.RefreshList();
                    })
                }
            }
        })
        menu.push({
            text: React.language('contact.handover.role.add'),
            colorType: "blue",
            icon: "icon-add",
            click: () => {
                this.addContactPane(checkList, checkListDetail);
            }
        })
        BsyAlertMenu({
            item: menu,
            // renderEl: event.currentTarget,
            width: 180,
            target: event.target
        })
    }

    openAddCorpLabelBatch = (event) =>{
        const {corpCoopList, contactList, checkList, checkListDetail} = this.state;

        let menu = corpCoopList.map((res, key)=>{
            return {
                text: res.name,
                colorType: "",
                line: key === corpCoopList.length - 1,
                click: () => {
                    React.axios("/corp/dock/corp/update", {
                        label_id: res.label_id,
                        dock_corpid: checkList
                    }).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        this.RefreshList();
                    })
                }
            }
        })
        menu.push({
            text: React.language('dept.label.add'),
            colorType: "blue",
            icon: "icon-add",
            click: () => {
                this.addCoopPane(checkList, checkListDetail);
            }
        })
        BsyAlertMenu({
            item: menu,
            // renderEl: event.currentTarget,
            width: 180,
            target: event.target
        })
    }

    removeCorpLabelBatch = () =>{
        const {selectGroup, selectType, checkList, checkListDetail} = this.state;
        let titile = '', msg = '';
        if(selectType === "corpCoopAll"){
            if(selectGroup === "corpCoopAll"){
                titile = React.language("contact.connection.selected.remove");
                msg = React.language("contact.connection.selected.remove.tip");
            }else{
                titile = React.language("label.dept.selected.remove");
                msg = React.language("label.dept.selected.remove.tip");
            }
            
        }else{
            if(selectGroup === "contactAll"){
                titile = React.language("contact.our.docker.remove.title");
                msg = React.language("contact.our.docker.remove.tip");
            }else{
                titile = React.language("contact.role.docker.remove.title");
                msg = React.language("contact.role.docker.remove.tip");
            }
        } 
        BsyAlert({
            title: titile,
            msg: msg,
            type: "warning",
            text4Ok: React.language("delete"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                if(selectType === "corpCoopAll"){
                    if(selectGroup === "corpCoopAll"){
                        React.axios("/corp/dock/corp/delete",{label_id: [], type: "corp", dock_corpid: checkList}).then(res=>{
                            this.RefreshList();
                        })
                    }else{
                        React.axios("/corp/dock/corp/delete",{label_id: [selectGroup], type: "label", dock_corpid: checkList}).then(res=>{
                            this.RefreshList();
                        })
                    }
                    
                }else{
                    let userId = checkListDetail.map(res1=>{
                        return [res1.dock_corpid, res1.user_id]
                    })
                    if(selectGroup === "contactAll"){
                        React.axios("/corp/dock/member/batch_delete",{type: "corp", user_id: userId}).then(res=>{
                            this.RefreshList();
                        })
                    }else{
                        React.axios("/corp/dock/member/batch_delete",{role_id: [selectGroup], type: "role", user_id: userId}).then(res=>{
                            this.RefreshList();
                        })
                    }
                } 
            }
        })
    }

    removeCorpLabel = (item) =>{
        const {selectGroup, selectType} = this.state;
        let titile = '', msg = '';
        if(selectType === "corpCoopAll"){
            if(selectGroup === "corpCoopAll"){
                titile = React.language("contact.connection.selected.remove");
                msg = React.language("contact.connection.selected.remove.tip");
            }else{
                titile = React.language("label.dept.selected.remove");
                msg = React.language("label.dept.selected.remove.tip");
            }
            
        }else{
            if(selectGroup === "contactAll"){
                titile = React.language("contact.our.docker.remove.title");
                msg = React.language("contact.our.docker.remove.tip");
            }else{
                titile = React.language("contact.role.docker.remove.title");
                msg = React.language("contact.role.docker.remove.tip");
            }
        } 
        BsyAlert({
            title: titile,
            msg: msg,
            type: "warning",
            text4Ok: React.language("delete"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                if(selectType === "corpCoopAll"){
                    if(selectGroup === "corpCoopAll"){
                        React.axios("/corp/dock/corp/delete",{label_id: [], type: "corp", dock_corpid: item.dock_corpid}).then(res=>{
                            this.RefreshList();
                        })
                    }else{
                        React.axios("/corp/dock/corp/delete",{label_id: [selectGroup], type: "label", dock_corpid: item.dock_corpid}).then(res=>{
                            this.RefreshList();
                        })
                    }
                    
                }else{
                    if(selectGroup === "contactAll"){
                        React.axios("/corp/dock/member/delete",{corp_id: [item.owner_corpid], type: "corp", user_id: [item.user_id]}).then(res=>{
                            if(res.data.errcode !== 0){
                                tipAlert({
                                    type: 'warning',
                                    msg: res.data.errmessage
                                })
                                return
                            }
                            this.RefreshList();
                        })
                    }else{
                        React.axios("/corp/dock/member/delete",{corp_id: [item.owner_corpid], role_id: [selectGroup], type: "role", user_id: [item.user_id]}).then(res=>{
                            if(res.data.errcode !== 0){
                                tipAlert({
                                    type: 'warning',
                                    msg: res.data.errmessage
                                })
                                return
                            }
                            this.RefreshList();
                        })
                    }
                } 
            }
        })
    }

    openAddPane = (event) =>{
        const $ = window.$;
        const FX = window.FX;
        const {item, dock_corp} = this.state;
        BsyAlertInviteUser({
            title: React.language('contact.handover.add'),
            styleCss: {
                width: 760,
                height: 540
            },
            departmentId: null,
            emailCodeLogin: this.emailCodeLogin,
            deptId: null,
            isAllDept: false,
            dock_corp: dock_corp,
            dock_corpid: "",
            isAddRoleLabel: true,
            isOther: true,
            onRefresh: (res) => {
                this.RefreshList()
            },
        })
    }

    addAgainCorp = (item) => {
        React.axios('/corp/dock/corp/reinvite', {
            dock_corpid: [item.dock_corpid],
            label_id: item.label_id
        }).then(res => {
            // const { target } = this.props;
            // target.parentNode.remove();
            tipAlert({
                type: 'success',
                msg: React.language('message.sended')
            })
            this.RefreshList();
        })
    }

    addAgainUser = (item) =>{
        React.axios('/corp/dock/member/reinvite', {
            dock_corpid: item.dock_corpid,
            memberIds: [item.user_id],
            role_id: item.role_id,
        }).then(res => {
            // const { target } = this.props;
            // target.parentNode.remove();
            tipAlert({
                type: 'success',
                msg: React.language('message.sended')
            })
            this.RefreshList();
        })
    }

    createContent = () =>{
        const {verifyBtn, isFilter, dock_corp, corpList, hasCorpList, selectGroupName, corpCoopList, contactList, limit, skip, selectGroup, filterText, selectType, checkList, checkListDetail, checked, corpCoopMap, contactMap, count, keyword} = this.state;
        const tipList = [
            {
                text: React.language("corp.coop.empty.tip1")
            },{
                text: React.language("corp.coop.empty.tip2")
            },{
                text: React.language("corp.coop.empty.tip3"),
                hasBtn: true
            },
        ];
        let list = []
        if(selectType === "corpCoopAll")
        {
            list = [{
                width: 147,
                key: "dock_corpname",
                value: React.language("openLink.auth.name.enterprise"),
                title: true,//给元素添加title属性
            }, {
                width: 147,
                key: "label_id",
                value: React.language("persona.corp.dept.label"),
                onCellCreate: (items, value) => {
                    return <>
                        {corpCoopMap[value.label_id] && <ul className="user-list" title={corpCoopMap[value.label_id].name}>
                            <li className="user-item">
                                <i className="icon-corp-label"></i>
                                <div className="user-name">{corpCoopMap[value.label_id].name}</div>
                            </li>
                        </ul>}
                    </>
                },
            }, {
                width: 147,
                key: "create_user",
                value: React.language("manager.creator"),
                onCellCreate: (items, value) => {
                    return <>
                        <span className="text">{value.create_user ? value.create_user.name : ""}</span>
                    </>
                },
            }, {
                width: 220,
                key: "dock_user",
                value: React.language("contact.handover.other"),
                onCellCreate: (items, value) => {
                    if(!value.dock_user){
                        return
                    }
                    let nameArray = value.dock_user.map((val)=>{
                        return val.name
                    })
                    return  <ul className="user-list" title={nameArray.join(',')}>
                        {
                            value.dock_user.map((val)=>{
                                const bg = val ? val.name ? BsyUtils.formatUserThumb(val.name.toString()) : '' : '';
                                return <li className="user-item">
                                    {val.avatarurl ? <img src={val.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                    <div className="user-name">{val.name}</div>
                                </li>
                            })
                        }
                    </ul>
                },
            }, {
                width: 220,
                key: "user",
                value: React.language("contact.handover.current"),
                onCellCreate: (items, value) => {
                    if(!value.user){
                        return
                    }
                    let nameArray = value.user.map((val)=>{
                        return val.name
                    })
                    return <ul className="user-list" title={nameArray.join(',')}>
                        {
                            value.user.map((val)=>{
                                const bg = val ? val.name ? BsyUtils.formatUserThumb(val.name.toString()) : '' : '';
                                return <li className="user-item">
                                    {val.avatarurl ? <img src={val.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                    <div className="user-name">{val.name}</div>
                                </li>
                            })
                        }
                    </ul>
                },
            }, {
                width: 80,
                key: "corp_status",
                value: "",
                onCellCreate: (items, value) => {
                    if(value.category !== -1){
                        return
                    }
                    let isGrey = "";
                    return <div className={"invite-btn" + isGrey} onClick={(event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        this.addAgainCorp(value);
                    }}>
                       {React.language('member.invite.again')}
                    </div>
                }
            }, {
                width: "100%",
                hasWidth: !0,
                key: "empty",
                value: "",
            }];
            if(selectGroup !== "corpCoopAll"){
                list = [{
                    width: 127,
                    key: "dock_corpname",
                    value: React.language("openLink.auth.name.enterprise"),
                    title: true,//给元素添加title属性
                }, {
                    width: 147,
                    key: "create_user",
                    value: React.language("manager.creator"),
                    onCellCreate: (items, value) => {
                        return <>
                            <span className="text">{value.create_user ? value.create_user.name : ""}</span>
                        </>
                    },
                }, {
                    width: 220,
                    key: "dock_user",
                    value: React.language("contact.handover.other"),
                    onCellCreate: (items, value) => {
                        if(!value.dock_user){
                            return
                        }
                        let nameArray = value.dock_user.map((val)=>{
                            return val.name
                        })
                        return  <ul className="user-list" title={nameArray.join(',')}>
                            {
                                value.dock_user.map((val)=>{
                                    const bg = val ? val.name ? BsyUtils.formatUserThumb(val.name.toString()) : '' : '';
                                    return <li className="user-item">
                                        {val.avatarurl ? <img src={val.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                        <div className="user-name">{val.name}</div>
                                    </li>
                                })
                            }
                        </ul>
                    },
                }, {
                    width: 220,
                    key: "user",
                    value: React.language("contact.handover.current"),
                    onCellCreate: (items, value) => {
                        if(!value.user){
                            return
                        }
                        let nameArray = value.user.map((val)=>{
                            return val.name
                        })
                        return <ul className="user-list" title={nameArray.join(',')}>
                            {
                                value.user.map((val)=>{
                                    const bg = val ? val.name ? BsyUtils.formatUserThumb(val.name.toString()) : '' : '';
                                    return <li className="user-item">
                                        {val.avatarurl ? <img src={val.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                        <div className="user-name">{val.name}</div>
                                    </li>
                                })
                            }
                        </ul>
                    },
                }, {
                    width: 177,
                    key: "",
                    value: "",
                }, {
                    width: 80,
                    key: "corp_status",
                    value: "",
                    onCellCreate: (items, value) => {
                        if(value.category !== -1){
                            return
                        }
                        let isGrey = "";

                        return <div className={"invite-btn" + isGrey} onClick={(event)=>{
                            event.stopPropagation();
                            event.preventDefault();
                            this.addAgainCorp(value);
                        }}>
                           {React.language('member.invite.again')}
                        </div>
                    }
                }, {
                    width: "100%",
                    hasWidth: !0,
                    key: "empty",
                    value: "",
                }];
            }
        }else if(selectType === "contactAll")
        {
            list = [{
                width: 187,
                key: "nickname",
                value: React.language("name"),
                title: true,//给元素添加title属性
            }, {
                width: 187,
                key: "corp",
                value: React.language("contact.handover.corp"),
                onCellCreate: (items, value) => {
                    return <span className="text">{value.dock_corpname ? value.dock_corpname : ""}</span>
                },
            }, {
                width: 147,
                key: "mobile",
                value: React.language("phone"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.mobile} className="text">{value.mobile }</span>
                        {value.mobile && value.mobilestatus == 0 && <div className="icon-cont">
                            <i className="icon-bsy-hint" onMouseEnter={(event) => {
                                window.FX.UI.showPopover({
                                    position: "top",
                                    anchor: window.$(event.target),
                                    content: window.$("<span/>").text(React.language('contact.docker.phone.verify.tip',{productName:window._bby_config.site_name})),
                                    type: "dark",
                                })
                            }} onMouseLeave={() => {
                                window.FX.UI.closePopover()
                            }}></i>
                        </div>}
                    </>
                    
                },
            }, {
                width: 197,
                key: "email",
                value: React.language("email"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.email} className="text">{value.email }</span>
                        {value.email && value.emailstatus == 0 && <div className="icon-cont">
                            <i className="icon-bsy-hint" onMouseEnter={(event) => {
                                window.FX.UI.showPopover({
                                    position: "top",
                                    anchor: window.$(event.target),
                                    content: window.$("<span/>").text(React.language('contact.docker.email.verify.tip',{productName:window._bby_config.site_name})),
                                    type: "dark",
                                })
                            }} onMouseLeave={() => {
                                window.FX.UI.closePopover()
                            }}></i>
                        </div>}
                    </>
                },
            }, {
                width: 176,
                key: "role_id",
                value: React.language("role"),
                onCellCreate: (items, value) => {
                    if(!value.role_id){
                        return
                    }
                    let nameArray = value.role_id.map((val)=>{
                        if(contactMap[val]){
                            return contactMap[val].name
                        }
                    })
                    return  <ul className="user-list" title={nameArray.join(',')}>
                        {
                            value.role_id.map((val)=>{
                                if(contactMap[val]){
                                    return <li className="user-item">
                                        <i className="icon-role"></i>
                                        <div className="user-name">{contactMap[val].name}</div>
                                    </li>
                                }
                            })
                        }
                    </ul>
                },
            },{
                width: 130,
                key: "dock_deptname",
                value: React.language("contact.docking.dept"),
                title: true,//给元素添加title属性
                onCellCreate: (items, value) => {
                    return value.dock_deptname && <div className={"dock_deptname_item"}>
                        <i className="icon-dept-title"></i>
                        <span className="text">{value.dock_deptname}</span>
                    </div>
                },
            }, {
                width: 80,
                key: "corp_status",
                value: "",
                onCellCreate: (items, value) => {
                    if(value.corp_status === 1 && (value.category === 2 || value.category === 0)){
                        return
                    }
                    let isGrey = "";
                    let hasTip = false;
                    if(value.corp_status === 0 && value.category === -1){
                        isGrey = " isGrey";
                        hasTip = true;
                    }
                    return <div className={"invite-btn" + isGrey} onClick={(event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        if(value.corp_status === 0 && value.category === -1){
                            return
                        }else if (value.corp_status === 0 && value.category === 0){
                            this.addAgainCorp(value);
                        }else if (value.corp_status === 1 && value.category === -1){
                            this.addAgainUser(value);
                        }
                    }} onMouseEnter={(event) => {
                        hasTip && window.FX.UI.showPopover({
                            position: "bottomLeft",
                            anchor: window.$(event.target),
                            content: window.$("<div style='width: 300px;' />").text(React.language('contact.handover.add.again.fail')),
                        })
                    }} onMouseLeave={() => {
                        hasTip && window.FX.UI.closePopover()
                    }}>
                       {React.language('contact.handover.add.again')}
                    </div>
                }
    
            }, {
                width: "100%",
                hasWidth: !0,
                key: "empty",
                value: "",
            }];
            if(selectGroup !== "contactAll"){
                list = [{
                    width: 207,
                    key: "nickname",
                    value: React.language("name"),
                    title: true,//给元素添加title属性
                }, {
                    width: 207,
                    key: "corp",
                    value: React.language("contact.handover.corp"),
                    onCellCreate: (items, value) => {
                        return <span className="text">{value.dock_corpname ? value.dock_corpname : ""}</span>
                    },
                }, {
                    width: 147,
                    key: "mobile",
                    value: React.language("phone"),
                    onCellCreate: (items, value) => {
                        return <>
                            <span title={value.mobile} className="text">{value.mobile }</span>
                            {value.mobile && value.mobilestatus == 0 && <div className="icon-cont">
                                <i className="icon-bsy-hint" onMouseEnter={(event) => {
                                    window.FX.UI.showPopover({
                                        position: "top",
                                        anchor: window.$(event.target),
                                        content: window.$("<span/>").text(React.language('contact.docker.phone.verify.tip',{productName:window._bby_config.site_name})),
                                        type: "dark",
                                    })
                                }} onMouseLeave={() => {
                                    window.FX.UI.closePopover()
                                }}></i>
                            </div>}
                        </>
                        
                    },
                }, {
                    width: 197,
                    key: "email",
                    value: React.language("email"),
                    onCellCreate: (items, value) => {
                        return <>
                            <span title={value.email} className="text">{value.email }</span>
                            {value.email && value.emailstatus == 0 && <div className="icon-cont">
                                <i className="icon-bsy-hint" onMouseEnter={(event) => {
                                    window.FX.UI.showPopover({
                                        position: "top",
                                        anchor: window.$(event.target),
                                        content: window.$("<span/>").text(React.language('contact.docker.email.verify.tip',{productName:window._bby_config.site_name})),
                                        type: "dark",
                                    })
                                }} onMouseLeave={() => {
                                    window.FX.UI.closePopover()
                                }}></i>
                            </div>}
                        </>
                    },
                }, {
                    width: 80,
                    key: "corp_status",
                    value: "",
                    onCellCreate: (items, value) => {
                        if(value.corp_status === 1 && (value.category === 2 || value.category === 0)){
                            return
                        }
                        let isGrey = "";
                        let hasTip = false;
                        if(value.corp_status === 0 && value.category === -1){
                            isGrey = " isGrey";
                            hasTip = true;
                        }
                        return <div className={"invite-btn" + isGrey} onClick={(event)=>{
                            event.stopPropagation();
                            event.preventDefault();
                            if(value.corp_status === 0 && value.category === -1){
                                return
                            }else if (value.corp_status === 0 && value.category === 0){
                                this.addAgainCorp(value);
                            }else if (value.corp_status === 1 && value.category === -1){
                                this.addAgainUser(value);
                            }
                        }} onMouseEnter={(event) => {
                            hasTip && window.FX.UI.showPopover({
                                position: "bottomLeft",
                                anchor: window.$(event.target),
                                content: window.$("<div style='width: 300px;' />").text(React.language('contact.handover.add.again.fail')),
                            })
                        }} onMouseLeave={() => {
                            hasTip && window.FX.UI.closePopover()
                        }}>
                           {React.language('contact.handover.add.again')}
                        </div>
                    }
        
                }, {
                    width: "100%",
                    hasWidth: !0,
                    key: "empty",
                    value: "",
                }, {
                    width: 116,
                    key: "",
                    value: "",
        
                }];
            }
        }
        return (<>
            {(hasCorpList || !!keyword || isFilter) ? <>
                <div className={"box-btn-pane"} style={{padding: checkList.length <= 0 ? "" : "8px 0"}}>
                    {
                        checkList.length <= 0 ? <>
                            {
                                (selectGroup === "corpCoopAll" || selectGroup === "contactAll") ? <>
                                    <div className="create-link-btn">
                                        {selectGroup === "corpCoopAll" && <div className="create-btn" onClick={this.openNewConnection}>
                                            <span>{React.language("contact.connection.new")}</span>
                                        </div>}
                                        {/*{selectGroup === "contactAll" && dock_corp.length > 0 && <div className="create-btn" onClick={this.openAddPane} style={{marginRight: 15}}>*/}
                                        {/*    <span>{React.language("contact.handover.add")}</span>*/}
                                        {/*</div>}*/}
                                        {selectGroup === "contactAll" && <div className="leading-btn" onClick={this.onLeading}>
                                            <span>{React.language("contact.handover.export.all")}</span>
                                        </div>}
                                        
                                    </div>
                                    <div className="filter-cont">
                                        <div className="filter-btn" onClick={this.filterPane}>
                                            <span>{filterText}</span>
                                            <i className="icon-bsy-xia"></i>
                                        </div>
                                        <div className="search-input">
                                            <BsySearchInput
                                                placeholder={selectGroup === "corpCoopAll" ? React.language('corp.search') : React.language('contact.search.name')}
                                                styleInput={{
                                                    'width': '200px',
                                                    height: '32px',
                                                    lineHeight: '30px'
                                                }}
                                                getValue={this.getSearchValue}
                                                onSearch={this.onSearch}
                                                value={keyword}
                                                type={window.mode}
                                                // iconName="icon-bsy-reportmenu-0"
                                            />
                                        </div>
                                    </div>
                                </>
                                  : <>
                                    <div className="create-link-btn">
                                        {selectType === "corpCoopAll" && <div className="create-btn" onClick={this.openAddCorpLabel}>
                                            <span>{React.language("label.dept.new")}</span>
                                        </div>}
                                        {selectType === "contactAll" && <div className="leading-btn" onClick={this.openAddRole}>
                                            <span>{React.language("contact.handover.add")}</span>
                                        </div>}
                                    </div>
                                    <div className="filter-cont">
                                        <div className="search-input">
                                            <BsySearchInput
                                                placeholder={selectGroup === "corpCoopAll" ? React.language('corp.search') : React.language('contact.search.name')}
                                                styleInput={{
                                                    'width': '200px',
                                                    height: '32px',
                                                    lineHeight: '30px'
                                                }}
                                                value={keyword}
                                                getValue={this.getSearchValue}
                                                onSearch={this.onSearch}
                                                type={window.mode}
                                                // iconName="icon-bsy-reportmenu-0"
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                          : <div className="check-menu">
                                <div className="close-btn" onClick={this.closeCheckMenu}>
                                    <i className="icon-close-large"></i>
                                </div>
                                <div className="total-cont">
                                    <span className="checked-num-wrapper">
                                        <span className="checked-title">{React.language('msg.target.set.selected')}</span>
                                        <span className="checked-num">{checkList.length}</span>
                                        /{corpList.length}
                                    </span>
                                </div>
                                {
                                    selectType === "corpCoopAll" && <div className="set-btn" onClick={this.openAddCorpLabelBatch}>
                                        <i className="icon-bsy-reportmenu-5"></i>
                                        <span>{React.language("label.set")}</span>
                                    </div>
                                }
                                {
                                    selectType === "contactAll" && <div className="set-btn" onClick={this.openAddCorpRoleBatch}>
                                        <i className="icon-bsy-reportmenu-5"></i>
                                        <span>{React.language("role.set")}</span>
                                    </div>
                                }
                                {
                                    selectGroup === "corpCoopAll" ? <div className="remove-btn" onClick={this.removeCorpLabelBatch}>
                                        <i className="icon-bsy-reportmenu-5"></i>
                                        <span>{React.language("contact.connection.remove")}</span>
                                    </div>:<div className="remove-btn" onClick={this.removeCorpLabelBatch}>
                                        <i className="icon-bsy-reportmenu-5"></i>
                                        <span>{React.language("remove.out")}</span>
                                    </div>
                                }

                            </div>
                    }
                </div>
                {this.onBsyTurnPageMid()}
                <BsyTableList
                    getValue={this.getTableValue}
                    limit={limit}
                    skip={skip}
                    skipChange={this.skipChange}
                    listLimitChange={this.listLimitChange}
                    listFilterChange={this.listFilterChange}
                    styleType={window.mode}
                    userCont={{
                        users:corpList
                    }}
                    noDarg={true}
                    list={list}
                    count={count}
                    hasTurnPage={!!count}
                    checkList={checkList}
                    checkListDetail={checkListDetail}
                    checked={checked}
                    multiple={selectGroup !== 'deleted'}
                    onRowOrder={e => { this.handleUserOrder(e) }}
                    onReinvite={e => { this.againAllInvite(e) }}
                    onRowClick={(e, node) => { this.memberRowClick(e, node) }}
                    onCheck={(e)=>{this.onCheck(e)}}
                />
                {
                    count === 0 && <div className="search-empty-tip">
                        <div className="empty-cont">
                            <img src={emptyImg3} alt="" />
                            <p>{React.language('contact.all.search.emptyTip')}</p>
                        </div>
                    </div>
                }
            </> : <>
                    {
                        selectGroup === "corpCoopAll"  ? <div className="empty-content-tip">
                        <div className="empty-box">
                            <div className="box-cont">
                                <img src={emptyImg} alt="" />
                                {
                                    tipList.map(val => {
                                        return <div className="setp">
                                            <span>{val.text}</span>
                                            {val.hasBtn && <a target="_blank" href="#">{React.language('learnMore')}</a>}
                                        </div>
                                    })
                                }
                                <div className="createBtn" onClick={this.openNewConnection}>
                                    <span>{React.language("contact.connection.new")}</span>
                                </div>
                            </div>
                        </div>
                        </div> : selectGroup === "contactAll" ? <div className="empty-content-tip">
                                <div className="content-tip">
                                    <div className="empty-img">
                                        <img src={emptyImg2} alt="" />
                                    </div>
                                    <div className="empty-tip">
                                        {React.language("contact.handover.guest.empty")}
                                    </div>
                                </div>
                            </div> : selectType === "corpCoopAll" ? <div className="empty-content-tip">
                            <div className="content-tip">
                                <div className="empty-img">
                                    <img src={emptyImg2} alt="" />
                                </div>
                                <div className="empty-tip">
                                    {React.language('label.dept.empty.corp.tip')}
                                </div>
                                <div className="empty-button">
                                    <div className="corpButton" onClick={this.openAddCorpLabel}>
                                        {React.language('label.dept.new')}
                                    </div>
                                </div>
                            </div>
                        </div> : <div className="empty-content-tip">
                            <div className="content-tip">
                                <div className="empty-img">
                                    <img src={emptyImg2} alt="" />
                                </div>
                                <div className="empty-tip" style={{"textAlign":"center"}}>
                                    {React.language('role.current.member.empty.add')}
                                </div>
                                <div className="empty-button">
                                    <div className="corpButton" onClick={this.openAddRole}>
                                        {React.language('contact.handover.add')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
            </>}
                    
                </>)
    }

    render(){
        const { isLoading, verifyBtn, hasRole, hasLabel, corpList, selectGroupName, corpCoopList, contactList, limit, skip, selectGroup, filterText, selectType, checkList, checkListDetail, checked, corpCoopMap, contactMap, count} = this.state;
        const tipList = [
            {
                text: React.language("corp.coop.empty.tip1")
            },{
                text: React.language("corp.coop.empty.tip2")
            },{
                text: React.language("corp.coop.empty.tip3"),
                hasBtn: true
            },
        ];
        
        return(
            <div className="BsyCorpCoop">
                <div className="corpCoopMenu">
                    <div className="menu-cont">
                        <div className="menu-list coop">
                            <div className="item-title">
                                <span>{React.language("external.dept")}</span>
                                <i className="icon-add" onClick={()=>{
                                    this.addCoopPane()
                                }} onMouseEnter={(event) => {
                                    window.FX.UI.showPopover({
                                        position: "bottomLeft",
                                        anchor: window.$(event.target),
                                        content: window.$("<span/>").text(React.language('dept.label.add')),
                                        type: "dark"
                                    })
                                }} onMouseLeave={() => {
                                    window.FX.UI.closePopover()
                                }}></i>
                            </div>
                            <div className={"menu-item" + (selectGroup === "corpCoopAll" ? " active":"")} onClick={()=>{
                                if(selectGroup === "corpCoopAll"){
                                    return
                                }
                                this.setState({filterText: React.language('all'), inviteStatus: 0,selectGroup:"corpCoopAll", label_id: 0,checkList:[], checkListDetail: [], checked: false, selectType: "corpCoopAll", keyword: "",selectGroupName:React.language('contact.corp.all')},()=>{
                                    this.RefreshList()
                                })
                            }}>
                                <div className="item-cont">
                                    <i className="icon-all-corp" style={{color: "#0265ff"}}></i>
                                    <span>{React.language('contact.corp.all')}</span>
                                </div>
                            </div>
                            {
                                corpCoopList.length > 0 && <BsyGroupList
                                    groups={corpCoopList}
                                    selectGroup={selectGroup}
                                    nodeClick={(node) => this.outsiderNodeClick(node, "corpCoopAll")}
                                    nodeAdd={() => this.outsiderNodeAdd()}
                                    hasMenu={true}
                                    outsiderMemberRemove={false}
                                    nodeSort={(attr) => this.outsiderGroupNodeMove(attr, corpCoopList, "label")}
                                    nodeMoreOperate={(e, node) => this.outsiderGroupMoreOperate(e, node)}
                                    sortable={BsyUtils.isSubAdmin() ? false : true}
                                    hasAdd={false}
                                    hasDeletedList={false}
                                    hasCustom={false}
                                    keyid={"label_id"}
                                />
                            }
                        </div>
                        <div className="menu-list corpUser">
                            <div className="item-title">
                                <span>{React.language("contact.handover")}</span>
                            </div>
                            <div className={"menu-item" + (selectGroup === "contactAll" ? " active":"")} onClick={()=>{
                                if(selectGroup === "contactAll"){
                                    return
                                }
                                this.setState({filterText: React.language('all'), inviteStatus: 0, selectGroup:"contactAll", role_id: 0,checkList:[], checkListDetail: [], checked: false, selectType: "contactAll", keyword: "",selectGroupName:React.language('contact.handover.all')},()=>{
                                    this.RefreshList()
                                })
                            }}>
                                <div className="item-cont">
                                    <i className="icon-all-docker" style={{color: "#FFC502"}}></i>
                                    <span>{React.language('contact.handover.all')}</span>
                                </div>
                            </div>
                        </div>
                        <div className="menu-list label">
                            <div className="item-title">
                                <span>{React.language("contact.handover.role")}</span>
                                <i className="icon-add" onClick={(event)=>{this.addContactPane()}} onMouseEnter={(event) => {
                                    window.FX.UI.showPopover({
                                        position: "bottomLeft",
                                        anchor: window.$(event.target),
                                        content: window.$("<span/>").text(React.language('contact.handover.role.add')),
                                        type: "dark"
                                    })
                                }} onMouseLeave={() => {
                                    window.FX.UI.closePopover()
                                }}></i>
                            </div>
                            {
                                contactList.length > 0 && <BsyGroupList
                                    groups={contactList}
                                    selectGroup={selectGroup}
                                    nodeClick={(node) => this.outsiderNodeClick(node, "contactAll")}
                                    nodeAdd={() => this.outsiderNodeAdd()}
                                    hasMenu={true}
                                    outsiderMemberRemove={false}
                                    nodeSort={(attr) => this.outsiderGroupNodeMove(attr, contactList, "role")}
                                    nodeMoreOperate={(e, node) => this.outsiderGroupMoreOperate(e, node)}
                                    // sortable={BsyUtils.isSubAdmin() ? false : true}
                                    sortable={true}
                                    hasAdd={false}
                                    hasDeletedList={false}
                                    hasCustom={false}
                                    keyid={"role_id"}
                                />
                            }
                        </div>
                    </div>
                    <div className="other-set" onClick={this.openOtherSetPane}>
                        <i className="icon-bsy-reportmenu-5"></i>
                        <span>{React.language('datahelper.trigger.config.next1')}</span>
                    </div>
                </div>
                <div className="corpCoopContent" ref={this.corpContEl}>
                    <div className={"cont-box "  + (count === 0 ? "noSearch" : "")}>
                        <div className="content-title">
                            <div className="title">
                                <span>{selectGroupName}</span>
                            </div>
                            <div className="title-msg">
                                <span>{selectGroup === "corpCoopAll" ? React.language('contact.corp.panel.tip') : selectGroup === "contactAll" ? React.language('contact.handover.panel.tip') : ""}</span>
                            </div>
                            {/* <div className="title-button">
                                {(selectGroup === "corpCoopAll" || selectGroup === "contactAll") && React.language('function.intro.detail')}
                            </div> */}
                        </div>
                        {!isLoading && this.createContent()}
                    </div>
                </div>
            </div>
        )
    }
}